import React, {useEffect, useRef, useState} from 'react';
import cn from 'classnames';

import Skeleton from 'coreComponents/Skeleton';
import {useGooglePay} from 'coreHooks';

import {TGooglePayButtonProps} from './IGooglePayButton';

const GooglePayButton = ({onClick, isProduct, classNames, section, popupGooglePayThreeDS}: TGooglePayButtonProps) => {
	const googlePayHandler = useGooglePay();
	const ref = useRef(null);
	let result = null;
	let googlePayButtonStyleConfig = {};
	const Component: any = popupGooglePayThreeDS ? popupGooglePayThreeDS : null;
	const [threeDSData, setThreeDSData] = useState({});

	if (googlePayHandler?.expressButtons && section) {
		googlePayButtonStyleConfig = googlePayHandler.expressButtons[section]?.buttonStyleConfig || {};
	}

	const handleClick = () => {
		const handleClickCallback = (threeDSJWT: string, threeDSActionURL: string, dfReferenceId: string) => {
			if (threeDSJWT && threeDSActionURL && dfReferenceId) {
				setThreeDSData((previousState) => {
					return {
						...previousState,
						threeDSJWT,
						threeDSActionURL,
						dfReferenceId
					};
				});
			}
		};

		if (isProduct) {
			onClick(handleProductCheckout);
		} else {
			googlePayHandler.handle(undefined, handleClickCallback);
		}
	};

	const handleProductCheckout = async (productId: string) => {
		googlePayHandler.handle(productId);
	};

	useEffect(() => {
		if (googlePayHandler.loaded && !ref.current.innerHTML) {
			const div = googlePayHandler.getButton(handleClick, googlePayButtonStyleConfig);
			ref.current.appendChild(div);

			const buttonRadius = parseInt(googlePayButtonStyleConfig?.buttonRadius, 10);

			if (buttonRadius) {
				ref.current.style.setProperty('--gpay-button-radius', `${buttonRadius}px`);
			}
		}
	}, [googlePayHandler.loaded]);

	if (googlePayHandler.loaded) {
		result = <div className={cn('gpay-button__wrapper', classNames)} ref={ref}></div>;
	} else if (googlePayHandler.loading) {
		result = <Skeleton height="20px" width="100px" />;
	}

	return (
		<>
			{Component && <Component threeDSData={threeDSData} />}
			{result}
		</>
	);
};

export default GooglePayButton;
